export const formatTime = (totalSeconds = 0) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const pad = (num: number) => String(num).padStart(2, '0');

    if (hrs > 0) {
        return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
    }

    return `${pad(mins)}:${pad(secs)}`;
};

export const formatTimeToMinutesSeconds = (totalSeconds: number): string => {
    const totalMinutes = Math.floor(totalSeconds / 60);

    if (totalMinutes >= 60) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours}h ${minutes}m`;
    }

    const seconds = Math.round(totalSeconds % 60);
    return `${totalMinutes}m ${seconds}s`;
};
